import { NgModule } from '@angular/core';
import { FireflyRedirectButtonComponent } from './redirect-button/redirect-button.component';

@NgModule({
  imports: [],
  declarations: [FireflyRedirectButtonComponent],
  exports: [FireflyRedirectButtonComponent]
})
export class FireflyButtonsModule {}
